import DefaultObjectOnScreen from '../categories/common/ObjectOnScreen';

export default function ObjectOnScreenFactory(objectType: string) {
  switch (objectType) {
    default:
      return DefaultObjectOnScreen;
  }
}
